import React, { Component } from "react"
import MetaTags from 'react-meta-tags';
import PropTypes from 'prop-types'
import { Link } from "react-router-dom"
import { connect } from "react-redux"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { withTranslation } from "react-i18next"
import "flatpickr/dist/themes/material_blue.css"
import Flatpickr from "react-flatpickr"
import axios from "axios";
import { classnames } from "helpers/helper";
import { Calendar } from 'primereact/calendar';
import 'primereact/resources/themes/lara-light-cyan/theme.css';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import Swal from 'sweetalert2'
import closeImg from "../../assets/img/close.png"
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  FormGroup,
  Label,
  Input,
  Button,
  InputGroup,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Offcanvas,
  OffcanvasHeader,
  OffcanvasBody,
  Nav,
  NavItem,
  NavLink,
  TabPane,
  TabContent
} from "reactstrap"
import ClientSidebar from "components/VerticalLayout/ClientSidebar";
import { API_URL } from "helpers/app_url";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import SaveButton from "components/buttons/save";
import RsLink from "components/buttons/rsLink";
import UpdateButton from "components/buttons/updateBtn";
import { getClientDetail } from "../../store/clients/actions"
import Moment from "react-moment";
import { values } from "lodash";
import { toast, ToastContainer } from "react-toastify";
import ActionDelete from "components/buttons/actionDelete";
import ActionConvertLead from "components/buttons/actionConvertLead";
import ActionInterested from "components/buttons/actionInterested";
import ConvertToLead from "./forms/convert-to-lead";
import moment from "moment";
import AiButton from "components/buttons/aiBtn";
import TimePicker from "components/dropdowns/Timepicker";
import SafeField from "helpers/SafeField";
class OpenList extends Component {
  constructor(props) {
    super(props)
    this.state = {
      activeTab: "1",
      ccTab: "1",
      visitorList: '',
      selectedItems: [],
      visitorsList: [],
    }
    this.toggleEditCanvas = this.toggleEditCanvas.bind(this);
    this.toggleSend = this.toggleSend.bind(this);
    this.toggleConvertLead = this.toggleConvertLead.bind(this);
    this.toggleInsterestedVisit = this.toggleInsterestedVisit.bind(this);
    this.handleLeadInterested = this.handleLeadInterested.bind(this);
  }
  toggleInterest() {
    this.setState(prevState => ({
      isInterestLead: !prevState.isInterestLead
    }));
  }
  toggleInsterestedVisit() {
    this.setState({ visitorList: "", isInterestLead: !this.state.isInterestLead });
    this.toggleInterest();
  }
  fetchInterestedOpenhouser(openhouseId){
    const obj = JSON.parse(localStorage.getItem("authUser"));
    const token = obj?.resultData?.bearerToken;
    const headers = {
        Authorization: `Bearer ${token}`, 
        "Content-Type": "application/json",
      };
  
      const params = {
        openhouseId: openhouseId,
      
      };
      axios
      .get(`${API_URL}ClientSellerOpenhouse/byid`, { headers, params })
      .then((response) => {
        this.setState({ openhouseData: response.data, loading: false });
      })
      .catch((error) => {
        this.setState({ error: error.message, loading: false });
      });
  }
  toggleInsterestedVisit = arg => {
    const visitorList = arg;
    this.fetchInterestedOpenhouser(visitorList.clientOpenhouseId);
    this.toggleInterest();
  }
  toggleConvert() {
    this.setState(prevState => ({
      isConverLead: !prevState.isConverLead
    }));
  }
  toggleConvertLead() {
    this.setState({ visitorList: "", isConverLead: !this.state.isConverLead });
    this.toggleConvert();
  }
  toggleConvertLead = arg => {
    const visitorList = arg;

    this.setState({
      visitorList: {
        id: visitorList.id,
        agentId: visitorList.agentId,
        firstName: visitorList.firstName,
        lastName: visitorList.lastName,
        email: visitorList.email,
        phone: visitorList.phone,
        phoneExt: visitorList.phoneExt,
        mobile: visitorList.mobile,

      },

    });
    this.toggleConvert();
  }
  handleSelectAll = () => {
    this.setState((prevState) => {
      const allSelected = prevState.selectedItems.length === prevState.visitorsList.length;
      const selectedItems = allSelected ? [] : prevState.visitorsList.map((visitor) => visitor.id);
      const selectedVisitors = allSelected ? [] : [...prevState.visitorsList];

      return { selectedItems, selectedVisitors };
    });
  };
  // handleSelectItem = (id) => {
  //   this.setState((prevState) => {
  //     const { selectedItems } = prevState;
  //     return {
  //       selectedItems: selectedItems.includes(id)
  //         ? selectedItems.filter((item) => item !== id)
  //         : [...selectedItems, id],
  //     };
  //   });
  // };
  handleSelectItem = (id) => {
    this.setState((prevState) => {
      const selectedItems = prevState.selectedItems.includes(id)
        ? prevState.selectedItems.filter((item) => item !== id)
        : [...prevState.selectedItems, id];
      const selectedVisitors = prevState.visitorsList.filter((visitor) =>
        selectedItems.includes(visitor.id)
      );
      return {
        selectedItems,
        selectedVisitors,
        leadIds: selectedItems,
      };
    });
  };

  toggleSend = () => {
    const selectedVisitors = this.state.visitorsList.filter((visitor) =>
      this.state.selectedItems.includes(visitor.id)
    );

    this.setState({ selectedVisitors, isSend: !this.state.isSend });
  };
  cctoggle(tab) {
    if (this.state.ccTab !== tab) {
      this.setState({
        ccTab: tab,
      });
    }
  }
  componentDidMount() {
    const { match: { params }, onGetClientDetail } = this.props;
    onGetClientDetail(params.clientId);
    this.fetchData();
  }
  fetchData = async () => {
    try {
      const obj = JSON.parse(localStorage.getItem("authUser"));
      const token = obj.resultData.bearerToken;
      const str = 'Bearer ' + token;
      const response = await axios.get(`${API_URL}ClientOpenhouseLead/allforopenhouse`, {
        headers: {
          'Authorization': str,
          'Content-Type': 'application/json',
        },
        params: {
          openhouseId: this.props.match.params.openhouseId
        },
      });
      this.setState({ visitorsList: response.data, loading: false });
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };
  toggle() {
    this.setState(prevState => ({
      isRight: !prevState.isRight
    }));
  }
  toggleEditCanvas() {
    this.setState({ isRight: !this.state.isRight });
    //this.toggle();
  }
  handleSendVisitorEmail = async (values) => {
    try {
      const obj = JSON.parse(localStorage.getItem("authUser"));
      const token = obj?.resultData?.bearerToken;
      if (!token) {
        console.error("Token not found!");
        return;
      }
      const headers = {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      };
      const updatedValues = {
        ...values,
        emailTemplateId: parseInt(values.emailTemplateId, 10) || 0,
      };
      toast.loading("Sending Email...");
      const response = await axios.post(`${API_URL}ClientOpenhouseLead/SendEmailToClientOpenhouseLead`, updatedValues, { headers });

      if (response.data.success) {
        toast.dismiss();
        toast.success("Email Sent Successfully");
        this.setState({ isSend: false });
      } else {
        toast.dismiss();
        toast.error("Failed to send email");
      }


    } catch (error) {

    }
  };
  handleDeleteVisitor = (visitor) => {
    Swal.fire({
      title: "Are you sure?",
      text: "This action cannot be undone.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        const obj = JSON.parse(localStorage.getItem("authUser"));
        const token = obj?.resultData?.bearerToken;
        axios
          .delete(`${API_URL}ClientOpenhouseLead/${visitor.id}`, {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          })
          .then((response) => {
            Swal.fire("Deleted!", "The visitor has been deleted.", "success");
            this.setState((prevState) => ({
              visitorsList: prevState.visitorsList.filter((d) => d.id !== visitor.id),
            }));
          })
          .catch((error) => {
            Swal.fire("Error!", "An error occurred while deleting the document.", "error");
          });
      }
    });
  }
  handleLeadInterested = async (values, actions) => {
      try {
        const obj = JSON.parse(localStorage.getItem("authUser"));
        const token = obj?.resultData?.bearerToken;
        
        if (!token) {
          console.error("Token not found!");
          toast.error("Authentication failed. Please log in again.");
          return;
        }
    
        const headers = {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        };
    
        // Construct the payload for lead submission
        const payload = {
          openhouseLeadId: parseInt(values.openhouseLeadId, 10) || 0,
          clientId: parseInt(this.props.match.params.id),
          agentId: parseInt(localStorage.getItem("userId")),
          clientListingId: values.clientListingId,
          showingDate: moment(values.showingDate).format("YYYY-MM-DD"),
          startTime: values.startTime,
          endTime: values.endTime,
          agentName: values.agentName,
          agentOrganization: values.agentOrganization,
          agentContact: values.agentContact,
          agentEmail: values.agentEmail,
          isActive: true
        };
  
        toast.loading("Please wait...");
        const leadResponse = await axios.post(`${API_URL}ClientOpenhouseLead/MarkOpenhouseLeadInterested`, payload, { headers });
    
        if (leadResponse.data.success) {
          toast.dismiss();
          toast.success("Saved successfully.");
          this.toggleInterest();
        } else {
          toast.dismiss();
          toast.error("Failed to set interested.");
        }
      } catch (error) {
        toast.dismiss();
        console.error("Error submitting lead:", error.response?.data || error.message);
      }
    };
    handleInsertAi = (generatedText, setFieldValue) => {
      //
      setFieldValue("emailLeadFullContent", generatedText);
    };
  render() {
    const { clietDetail } = this.props;
    const { visitorsList, selectedItems, visitorList, openhouseData } = this.state;
    return (
      <React.Fragment>
        <ToastContainer autoClose={2000} />
        <div className="page-content project-page-content">
          <MetaTags>
            <title>Client Dashboard | Realty Space</title>
          </MetaTags>
          <Container fluid className="ps-0">
            <Row>
              <Col sm='2' className="pe-0">
                <ClientSidebar clientDetail={clietDetail} />
              </Col>
              <Col sm='10' className="ps-0 pe-0">
                <Row className="project-header">
                <Col sm="7">
                  <Breadcrumbs
                    title={this.props.t("Clients")}
                    breadcrumbItem={this.props.t("Open House")}
                  />
                 </Col>
            <Col sm="4" className="">
                {/* <h2 className="">{this.props.t( clietDetail.firstName + " " + clietDetail.lastName)}</h2> */}
                <img src={closeImg} style={{width:40, marginTop:15, cursor:'pointer'}} className="float-end" alt="close" onClick={this.props.history.goBack} />
                </Col> 
                </Row>
                <Row>
                  <Col sm="12">
                    <Card>
                      <CardBody>
                        <h5 className="card-title">Visitors
                        <span className="float-end" style={{ marginRight: 80 }}>
                        {this.state.selectedVisitors?.length > 0 ? (
                          <RsLink iconClass="mdi mdi-update" onClick={this.toggleSend}>
                            Visitor Update
                          </RsLink>
                        ) : (
                          <Link className="btn btn-cancle" to="#" style={{ opacity: 0.5, pointerEvents: 'none' }}>
                           <i className="mdi mdi-update"></i> Visitor Update
                          </Link>
                        )}
                      </span>
                        </h5>
                        <div className="">
                          <table className="table table-striped">
                            <thead>
                              <tr>
                                <th>
                                  <input
                                    type="checkbox"
                                    className="selection-input-4"
                                    onChange={this.handleSelectAll}
                                    checked={selectedItems.length === visitorsList.length}
                                  />
                                </th>
                                <th>#</th>
                                <th>Name</th>
                                <th>Date</th>
                                <th>Questions</th>
                                <th>Contact</th>
                                <th>Action</th>

                              </tr>
                            </thead>
                            <tbody>
                              {visitorsList && visitorsList.length > 0 &&
                                visitorsList.map((item, key) => (
                                  <tr key={item.id}>
                                    <td>

                                      <input
                                        type="checkbox"
                                        className="selection-input-4"
                                        checked={selectedItems.includes(item.id)}
                                        onChange={() => this.handleSelectItem(item.id)}
                                      />
                                    </td>
                                    <td>{key+1}</td>
                                    <td>{item.firstName + " " + item.lastName}</td>
                                    <td><Moment format="MMM d YYYY">{item.createdDate}</Moment></td>
                                    <td>
                                      Are you Pre-Approved? - {item.preApprovedMortgage ? 'Yes' : 'No'}<br />
                                      How soon looking to move? - {item.howSoonLookingFor}<br />
                                      Currently working with an agent? -  {item.currentlyWorkingWithAgent ? 'Yes' : 'No'} </td>
                                    <td>
                                      Email : {item.email}<br />
                                      Cell : {item.mobile} </td>
                                    <td>
                                      <ActionDelete onClick={() => this.handleDeleteVisitor(item)} /> {" "} <ActionConvertLead onClick={() => this.toggleConvertLead(item)} /> {" "} <ActionInterested onClick={() => this.toggleInsterestedVisit(item)} />


                                      {/* <UncontrolledDropdown direction="up">
                              <DropdownToggle className="btn btn-action" type="button" id="defaultDropdown">
                                  Action <i className="mdi mdi-chevron-down"></i>
                              </DropdownToggle>
                              <DropdownMenu>
                                  <DropdownItem  href="#" onClick={()=>this.toggleEditCanvas()}>View Details</DropdownItem>
                                  <DropdownItem  href="#">Convert to Lead</DropdownItem>
                                  <DropdownItem  href="#">Delete</DropdownItem>


                              </DropdownMenu>
                          </UncontrolledDropdown> */}
                                    </td>
                                  </tr>
                                ))}

                            </tbody>
                          </table>
                        </div>
                      </CardBody>
                    </Card>
                  </Col>
                </Row>

              </Col>

            </Row>
            <Offcanvas
              isOpen={this.state.isConverLead}
              direction="end"
              toggle={this.toggleConvertLead}
              style={{ width: 800 }}
            >
              <OffcanvasHeader toggle={this.toggleConvertLead}>
                Converto To Lead
              </OffcanvasHeader>
              <OffcanvasBody>
                <ConvertToLead lead={visitorList} toggleAddNew={this.toggleConvertLead} />
              </OffcanvasBody>
            </Offcanvas>
            <Offcanvas
              isOpen={this.state.isSend}
              direction="end"
              toggle={this.toggleSend}
            >
              <OffcanvasHeader toggle={this.toggleSend}>
                Send Document
              </OffcanvasHeader>
              <OffcanvasBody>
                <Formik
                  enableReinitialize={true}
                  initialValues={{
                    agentId: parseInt(localStorage.getItem("userId")),
                    emailTemplateId: (this.state && this.state.emailTemplateId) || "",
                    emailLeadSubject: (this.state && this.state.emailLeadSubject) || "",

                    isActive: true,
                    leadIds: this.state.leadIds || [],
                    emailLeadFullContent:""

                  }}
                  validationSchema={Yup.object().shape({
                    emailTemplateId: Yup.string().required("This is Required"),
                    emailLeadSubject: Yup.string().required("This is Required")
                  })}

                  onSubmit={this.handleSendVisitorEmail}
                >
                  {({ errors, touched, values, handleChange, setFieldValue }) => (
                    <Form
                      className="needs-validation"
                    >


                      <Row>
                        <Col sm="12"><h5>Visitor : {this.state.selectedVisitors.length}</h5></Col>
                        {/* {this.state.selectedVisitors.length > 0 ? (
                this.state.selectedVisitors.map((visitor, index) => (
                  <div key={visitor.id}>
                    <h6>{index + 1}. {visitor.firstName} {visitor.lastName}</h6>
                    <p>Email: {visitor.email}</p>
                  </div>
                ))
              ) : (
                <p>No visitors selected.</p>
              )} */}
                        <Col sm="12">
                          <FormGroup className="mb-3">
                            <Label htmlFor="emailTemplateId">
                              {this.props.t("Select Email to send")}
                            </Label>
                            <SafeField
                              as="select"
                              onChange={handleChange}
                              type="text"
                              name="emailTemplateId"
                              className={
                                "form-control" +
                                (errors.emailTemplateId && touched.emailTemplateId
                                  ? " is-invalid"
                                  : "")
                              }

                              id="emailTemplateId"
                            >
                              <option value="">Select</option>
                              <option value="1">Instructions for Offers</option>
                              <option value="2">Upcoming Open house</option>
                              <option value="3">Property available for Offer</option>
                              <option value="4">Property now sold</option>
                              <option value="5">Property price revised</option>
                            </SafeField>
                            <ErrorMessage
                              name="emailSubject"
                              component="div"
                              className="invalid-feedback"
                            />
                          </FormGroup>
                        </Col>
                        <Col sm="12">
                          <FormGroup className="mb-3">
                            <Label htmlFor="emailLeadSubject">
                              {this.props.t("Subject *")}
                            </Label>
                            <SafeField
                              name="emailLeadSubject"
                              type="text"
                              className={
                                "form-control" +
                                (errors.emailLeadSubject && touched.emailLeadSubject
                                  ? " is-invalid"
                                  : "")
                              }
                              id="name"
                            />
                            <ErrorMessage
                              name="emailLeadSubject"
                              component="div"
                              className="invalid-feedback"
                            />
                          </FormGroup>
                        </Col>
                        <Col sm="12">
                          <FormGroup>
                            {/* <h6 style={{ marginTop: 30 }}>

                                <strong>{this.props.t("Content")}</strong>
                              </h6> */}
                            <Label htmlFor="emailLeadFullContent" className="w-100">Email Content

                               <span className="float-end"> <AiButton onInsert={(text) => this.handleInsertAi(text, setFieldValue)} /> </span>
                            </Label>
                            <CKEditor
                              editor={ClassicEditor}
                              data={values.emailLeadFullContent}
                              onChange={(event, editor) => {
                                const data = editor.getData();
                                setFieldValue('emailLeadFullContent', data);
                              }}

                            />
                          </FormGroup>
                        </Col>
                        <Col sm="12">

                          <UpdateButton iconClass="bx bx-send">{this.props.t("Send")}</UpdateButton>{" "}

                        </Col>
                      </Row>


                    </Form>
                  )}
                </Formik>

              </OffcanvasBody>
            </Offcanvas>

            <Offcanvas
              isOpen={this.state.isInterestLead}
              direction="end"
              toggle={this.toggleInsterestedVisit}

            >
              <OffcanvasHeader toggle={this.toggleInsterestedVisit}>
                Interested in property. Add to list of showings.
              </OffcanvasHeader>
              <OffcanvasBody>
                <Formik
                  enableReinitialize={true}
                  initialValues={{
                    openhouseLeadId:openhouseData?.id,
                    clientListingId:openhouseData?.clientListingId,
                  
                    showingDate: openhouseData?.openhouseDate,
                    startTime	: openhouseData?.startTime,
                    endTime	: openhouseData?.endTime
                  }}
                  validationSchema={Yup.object().shape({
                    //clientListingId: Yup.string().required("This is Required"),
                    showingDate: Yup.string().required("This is Required"),
                  })}

                  onSubmit={this.handleLeadInterested}
                >
                  {({ errors, touched, values, handleChange, setFieldValue, setFieldTouched }) => (
                    <Form
                      className="needs-validation"
                    >

                      <Row>
                        <Col sm="4">
                          <FormGroup className="mb-3">
                            <Label htmlFor="showingDate">
                              {this.props.t("Date")}
                            </Label>
                            <InputGroup>
                              <Flatpickr
                                name="showingDate"
                                readOnly={true}
                                className={
                                  "form-control" +
                                  (errors.showingDate && touched.showingDate
                                    ? " is-invalid"
                                    : "")
                                }
                                placeholder=""
                                value={values.showingDate}
                                onChange={(value) => setFieldValue('showingDate', value[0])}
                                options={{
                                  altInput: true,
                                  altFormat: "F j, Y",
                                  dateFormat: "Y-m-d",
                                  minDate: "today"
                                }}
                              />
                            </InputGroup>
                          </FormGroup>
                        </Col>

                        <Col sm="4">
                          <TimePicker
                            name="startTime"
                            label="Start Time *"
                            value={values.startTime}
                            onChange={(val) => setFieldValue("startTime", val)}
                            onBlur={() => setFieldTouched("startTime", true)}
                            minTime={null}
                            error={errors.startTime}
                            touched={touched.startTime}
                          />
                        
                        </Col>

                        <Col sm="4">
                          <TimePicker
                            name="endTime"
                            label="End Time *"
                            value={values.endTime}
                            onChange={(val) => setFieldValue("endTime", val)}
                            onBlur={() => setFieldTouched("endTime", true)}
                            minTime={values.startTime}
                            disabled={!values.startTime}
                            error={errors.endTime}
                            touched={touched.endTime}
                          />
                       
                        </Col>
                        {/* <Col sm="12">
                          <FormGroup className="mb-3">
                            <Label htmlFor="agentName">
                              {this.props.t("Agent Name")}
                            </Label>
                            <SafeField
                              name="agentName"
                              onChange={handleChange}
                              type="text"
                              className={
                                "form-control" +
                                (errors.agentName && touched.agentName
                                  ? " is-invalid"
                                  : "")
                              }
                              id="agentName"
                            />
                            <ErrorMessage
                              name="agentName"
                              component="div"
                              className="invalid-feedback"
                            />
                          </FormGroup>
                        </Col>
                        <Col sm="12">
                          <FormGroup className="mb-3">
                            <Label htmlFor="agentOrganization">
                              {this.props.t("Agent Organization")}
                            </Label>
                            <SafeField
                              name="agentOrganization"
                              onChange={handleChange}
                              type="text"
                              className={
                                "form-control" +
                                (errors.agentOrganization && touched.agentOrganization
                                  ? " is-invalid"
                                  : "")
                              }
                              id="agentOrganization"
                            />
                            <ErrorMessage
                              name="agentOrganization"
                              component="div"
                              className="invalid-feedback"
                            />
                          </FormGroup>
                        </Col>
                        <Col sm="12">
                          <FormGroup className="mb-3">
                            <Label htmlFor="agentContact">
                              {this.props.t("Agent Contact")}
                            </Label>
                            <SafeField
                              name="agentContact"
                              onChange={handleChange}
                              type="text"
                              className={
                                "form-control" +
                                (errors.agentContact && touched.agentContact
                                  ? " is-invalid"
                                  : "")
                              }
                              id="agentContact"
                            />
                            <ErrorMessage
                              name="agentContact"
                              component="div"
                              className="invalid-feedback"
                            />
                          </FormGroup>
                        </Col>

                        <Col sm="12">
                          <FormGroup className="mb-3">
                            <Label htmlFor="agentEmail">
                              {this.props.t("Agent Email *")}
                            </Label>
                            <SafeField
                              name="agentEmail"
                              onChange={handleChange}
                              type="text"
                              className={
                                "form-control" +
                                (errors.agentEmail && touched.agentEmail
                                  ? " is-invalid"
                                  : "")
                              }
                              id="agentEmail"
                            />
                            <ErrorMessage
                              name="agentEmail"
                              component="div"
                              className="invalid-feedback"
                            />
                          </FormGroup>
                        </Col> */}





                      </Row>

                      <div className="clearfix"><SaveButton></SaveButton></div>


                    </Form>
                  )}
                </Formik>
              </OffcanvasBody>
            </Offcanvas>
          </Container>
        </div>
      </React.Fragment>
    )
  }
}
OpenList.propTypes = {
  t: PropTypes.any,
  match: PropTypes.object,
  history: PropTypes.object,
  onGetClientDetail: PropTypes.func,
  clietDetail: PropTypes.object,

}
const mapStateToProps = ({ Clients }) => (
  {
    clietDetail: Clients.clietDetail

  })
const mapDispatchToProps = dispatch => ({
  onGetClientDetail: clientId => dispatch(getClientDetail(clientId))
});
export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(OpenList))
